'use client';

import { useEffect, useState } from 'react';
import { getAdjustTrackingLink } from '@/lib/adjust-tracking';

export function useAdjustTrackingLink(): string | null {
  const [adjustLink, setAdjustLink] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const link = getAdjustTrackingLink(searchParams);

    if (link) {
      setAdjustLink(link);
    } else {
      setAdjustLink(null);
    }
  }, []);

  return adjustLink;
}
